import { render, staticRenderFns } from "./CreateCustomFunds.vue?vue&type=template&id=b702d5ea&"
import script from "./CreateCustomFunds.vue?vue&type=script&lang=js&"
export * from "./CreateCustomFunds.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomFunds.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports